import { ForgotPassword } from 'src/sections/auth';

// ----------------------------------------------------------------------

export default function ForgotPasswordPage() {
  return (
    <ForgotPassword />
  );
}
